import React from 'react';
import { Route, Switch } from 'react-router';
import pkg from '../package.json';
import routes from './routes';

const App = () => (
  <div data-app-version={pkg.version}>
    <Switch>
      {routes.map((params, i) => (
        <Route key={i} {...params} />
      ))}
    </Switch>
  </div>
);

export default App;
